import { render, staticRenderFns } from "./comentarios.vue?vue&type=template&id=a0c531de&scoped=true"
import script from "./comentarios.vue?vue&type=script&lang=js"
export * from "./comentarios.vue?vue&type=script&lang=js"
import style0 from "./comentarios.vue?vue&type=style&index=0&id=a0c531de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c531de",
  null
  
)

export default component.exports